import { IconButton, styled } from '@mui/material';

export const StyledGoalsCreateHeaderWrap = styled('div')({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	position: 'relative',
});

export const StyledGoalsCreateHeaderCloseIcon = styled(IconButton)({
	background: '#FFFFFFB2',
	padding: '4px',
});

export const StyledGoalsCreateHeaderGoBack = styled('div')(({ theme }) => ({
	display: 'flex',
	alignItems: 'center',
	gap: '6px',
	padding: '2px 12px',
	color: theme.palette.primary.main,
	cursor: 'pointer',
}));
